import { createContext, useContext } from 'react';
import { getSplitterDataProvider } from '../__internal__/SplitterDataProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const PersistedSplitterContext = /*#__PURE__*/createContext(undefined);
PersistedSplitterContext.displayName = 'PersistedSplitter';
export const PersistedSplitterProvider = props => {
  return /*#__PURE__*/_jsx(PersistedSplitterContext.Provider, {
    value: props.value ?? getSplitterDataProvider(),
    children: props.children
  });
};
export const usePersistedSplitter = () => {
  return useContext(PersistedSplitterContext);
};
//# sourceMappingURL=PersistedSplitterProvider.js.map